// extracted by mini-css-extract-plugin
module.exports = {"seoText":"SeoText-module--seoText--2Qkfo","bar":"SeoText-module--bar--1Bwa6"};